import { isDataGroupArray } from '@shopify/polaris-viz-core';

function checkForMismatchedData(data) {
  if (data == null || data.length === 0) {
    return;
  }

  if (isDataGroupArray(data)) {
    checkDataGroup(data);
  } else {
    checkDataSeries(data);
  }
}

function checkDataSeries(data, type = 'DataSeries') {
  if (data[0].data == null) {
    return false;
  }

  const firstSetLength = data[0].data.length;
  const hasMismatchedData = data.some(series => series.data.length !== firstSetLength);

  if (hasMismatchedData) {
    // eslint-disable-next-line no-console
    console.warn(`The ${type}[] provided does not have equal series values.`, data);
    return true;
  }
}

function checkDataGroup(group) {
  group.some(({
    series
  }) => checkDataSeries(series, 'DataGroup'));
}

export { checkForMismatchedData };
